import { CloseOutlined } from '@ant-design/icons';
import { Button, Card, Form, Input, Space, DatePicker, Select } from 'antd';
import { useEffect, useState } from 'react';
import { myResourceList } from "@/apis/discover";
import intl from 'react-intl-universal';
const { RangePicker } = DatePicker;
const ContentForm = ({ msg }) => {
	const [dataSource, setDataSource] = useState([]);
	const getMyResourceList = () => {
		myResourceList({
			isCreat: true,
			isCollect: true
		}).then(res => {
			const arr = res.data?.records || []
			setDataSource(arr.map(item => {
				return {
					value: item.resourceUuid,
					label: item.title,
				}
			}))
		}).catch(err => { })
	}

	useEffect(() => {
		getMyResourceList()
	}, [])


	return (
		<Form.List name="courseItems">
			{(fields, { add, remove }) => (
				<div
					style={{
						display: 'flex',
						rowGap: 16,
						flexDirection: 'column',
						marginBottom: 30
					}}
				>
					{fields.map((field) => (
						<Card
							size="small"
							title={intl.get("Course.Lesson No",{No:field.name + 1})}
							key={field.key}
							extra={
								<CloseOutlined
									onClick={() => {
										remove(field.name);
									}}
								/>
							}
						>
							<Form.Item label={intl.get("Course.Title of a short lesson")} name={[field.name, 'subCourseName']} rules={[
								{
									required: true,
									message: msg
								},
							]}>
								<Input />
							</Form.Item>

							<Form.Item
								 label={intl.get("Course.Class time")}
								name={[field.name, 'date']}
								
								rules={[
									{
										required: true,
										message: msg
									},
								]}
							>
								<RangePicker
									// format="YYYY-MM-DD HH:mm"
									format={["YYYY-MM-DD HH:mm", "YYYY-MM-DD HH:mm"]}
									style={{ width: "100%" }}
									showTime
								/>
							</Form.Item>

							<Form.Item>
								<Form.List name={[field.name, 'courseMaterials']}>
									{(subFields, subOpt) => (
										<div
											style={{
												display: 'flex',
												flexDirection: 'column',
												rowGap: 16,
											}}
										>
											{subFields.map((subField) => (
												<Space key={subField.key} style={{ border: "1px dashed #d9d9d9", padding: "10px 20px 0" }}>
													<div style={{ width: "500px", marginRight: 30 }}>
														<Form.Item  label={intl.get("Course.Description of information")} name={[subField.name, 'materialDescription']}>
															<Input.TextArea rows={4} />
														</Form.Item>
														<Form.Item  label={intl.get("Course.Select information")} name={[subField.name, 'resourceUuid']}>
															<Select
																options={dataSource}
															/>
														</Form.Item>
													</div>
													<CloseOutlined
														onClick={() => {
															subOpt.remove(subField.name);
														}}
													/>
												</Space>
											))}
											<Button type="dashed" onClick={() => subOpt.add()} block>
												+  {intl.get("Course.Additional information")}
											</Button>
										</div>
									)}
								</Form.List>
							</Form.Item>
						</Card>
					))}

					<Button type="dashed" onClick={() => add()} block>
						+ {intl.get("Course.Add the next lesson")}
					</Button>
				</div>
			)}
		</Form.List>
	);
};
export default ContentForm;